import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { configuredStore, history } from './redux';
import muiTheme from './constants/theme';
import Router from './Router';
import './App.css';
import { useKeyboardPadding } from './hooks/useKeyboardPadding';

const { store, persistor } = configuredStore;

function App() {

  useKeyboardPadding();


  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={history}>
          <MuiThemeProvider theme={muiTheme}>
            <CssBaseline>
              <Router />
            </CssBaseline>
          </MuiThemeProvider>
        </ConnectedRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
